<template>
  <div class="box">
    <a-card>
      <div class="box-top">
        <h2>活动列表</h2>
        <Activity @fatherMethod="fatherMethod"></Activity>
      </div>
      <a-table
        :columns="columns"
        :dataSource="data"
        bordered
      >
      <template slot="ActivityTime" slot-scope="text, record">
        <span>{{ record.ActivityEndTime}}</span> / <span>{{record.JizanEndTime}}</span>
      </template>
       <template slot="operation" slot-scope="text, record">
          <span>
            <a-popconfirm @confirm="end(record)" title="是否要提前结束？此操作不可撤销！">
              <a>提前结束</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a @click="extension(record)">推广</a>
            <a-divider type="vertical" />
            <a @click="edit(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="seedata(record)">数据</a>
            <a-divider type="vertical" />
            <a-popconfirm title="是否删除？此操作不可撤销！" @confirm="remove(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </template>
      </a-table>
    </a-card>
    <!-- 编辑 -->
    <a-modal
      title="活动配置"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="700"
    >
      <a-form-model v-bind="layout" :model="ruleForm" :rules="rules" ref="refForm">
        <a-form-model-item  label="活动ID">
          <a-input :disabled='true' placeholder="系统会自动分配的哦" v-model="ruleForm.activityId"/>
        </a-form-model-item>
        <a-form-model-item prop="mainTitle" label="活动名称" has-feedback>
          <a-input v-model="ruleForm.mainTitle"/>
        </a-form-model-item>
        <a-form-model-item prop="activityStartDate" has-feedback label="活动开始日期">
          <a-date-picker
            v-model="ruleForm.activityStartDate"
            show-time
            @change="Startchange"
            style="width:100%"
            placeholder=""
          />
        </a-form-model-item>
        <a-form-model-item prop="deadline" label="活动截止日期" has-feedback>
          <a-date-picker
            v-model="ruleForm.deadline"
            show-time
            @change="Endchange"
            style="width:100%"
            placeholder=""
          />
        </a-form-model-item>
        <a-form-model-item prop="max" label="集赞数" has-feedback>
          <a-input placeholder="满足集赞数可获得奖品" v-model="ruleForm.max"/>
        </a-form-model-item>
        <a-form-model-item prop="Prize" label="实物奖品" has-feedback>
          <a-input placeholder='用户成功完成积攒可获得的奖品' v-model="ruleForm.Prize"/>
        </a-form-model-item>
        <a-form-model-item prop="Cycle" label="发放周期（数字）" has-feedback>
          <a-input placeholder='活动结束后X个工作日内安排发奖' v-model="ruleForm.Cycle"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 查看数据 -->
    <a-modal
      title="用户数据"
      :visible="vis"
      @ok="dataOk"
      @cancel="dataCancel"
      :width="500"
    >
      <a-form-model v-bind="layout" :model="userForm">
        <a-form-model-item  label="中奖总人数">
          <a-input v-model="userForm.num" :disabled='true'/>
        </a-form-model-item>
        <a-form-model-item  label="游戏总人数">
          <a-input v-model="userForm.gamepeople" :disabled='true'/>
        </a-form-model-item>
        <a-form-model-item  label="游戏总次数">
          <a-input v-model="userForm.gamenum" :disabled='true'/>
        </a-form-model-item>
        <a-form-model-item  label="进入插件总次数">
          <a-input v-model="userForm.plugnum" :disabled='true'/>
        </a-form-model-item>
        <a @click="detailed">查看详细信息</a>
      </a-form-model>
    </a-modal>
    <!-- 查看详细信息 -->
    <a-modal
      :visible="visdetailed"
      @ok="detailedOk"
      @cancel="detailedCancel"
      :width="1400"
    >
      <div class="box-top">
        <h2>中奖用户列表</h2>
        <a-button @click="conbtn" type="primary">活动配置</a-button>
      </div>
      <a-table
        :columns="Acolumns"
        :dataSource="Adata"
        bordered
      >
      </a-table>
    </a-modal>
    <!-- 活动配置 -->
    <a-modal
      :visible="configure"
      @ok="conOk"
      @cancel="conCancel"
      :width="400"
    >
      <p><span>活动ID：</span><span>{{condata.ActivityId}}</span></p>
      <p><span>活动名称：</span><span>{{condata.ActivityName}}</span></p>
      <p><span>活动起始时间：</span><span>{{condata.ActivityStartTime}}</span></p>
      <p><span>活动结束时间：</span><span>{{condata.ActivityEndTime}}</span></p>
      <p><span>实物奖品：</span><span>{{condata.Prize}}</span></p>
      <p><span>发放周期（数字）：</span><span>{{condata.Cycle}}</span></p>
    </a-modal>
    <a-modal
      title="推广活动"
      :visible="extensionvis"
      @ok="extensionOk"
      @cancel="extensionCancel"
      :width="600"
    >
    <div>
      <div class="address">
        <h2>小程序地址</h2>
        <a-input v-model="aform.aone" style="width:62%" :disabled='true'/>
        <a-button class="activity1" type="primary" :data-clipboard-text='aform.aone' @click="copyo">复制</a-button>
      </div>
    </div>
    </a-modal>
  </div>
</template>

<script>
import AV from 'leancloud-storage'
import Activity from '@/components/addActivity'
import Clipboard from 'clipboard'
export default {
  name: 'page',
  components: {
    Activity
  },
  data () {
    const checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('必填项不能为空'))
      }
      if (isNaN(value)) {
        callback(new Error('请输入数字'))
      } else {
        return callback()
      }
    }
    return {
      recordID: '',
      data: [],
      vis: false,
      visdetailed: false,
      configure: false,
      extensionvis: false,
      columns: [
        {
          title: '活动Id',
          dataIndex: 'activityId',
          align: 'center',
          scopedSlots: { customRender: 'ActivityId' }
        },
        {
          title: '活动名称',
          dataIndex: 'mainTitle',
          align: 'center',
          scopedSlots: { customRender: 'mainTitle' }
        },
        {
          title: '活动开始日期',
          dataIndex: 'activityStartDate',
          align: 'center',
          scopedSlots: { customRender: 'activityStartDate' }
        },
        {
          title: '活动截止日期',
          dataIndex: 'deadline',
          align: 'center',
          scopedSlots: { customRender: 'deadline' }
        },
        {
          title: '所需集赞数',
          dataIndex: 'max',
          align: 'center',
          scopedSlots: { customRender: 'GameNumber' }
        },
        {
          title: '活动状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 300,
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      dese: [],
      visible: false,
      ruleForm: {
        activityld: '',
        mainTitle: '',
        activityStartDate: '',
        deadline: '',
        max: '',
        Prize: '',
        Cycle: ''
      },
      layout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 14 }
      },
      // 验证规则
      rules: {
        mainTitle: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        max: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { validator: checkAge, trigger: 'blur' }
        ],
        activityStartDate: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        deadline: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        Prize: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        Cycle: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { validator: checkAge, trigger: 'change' }
        ]
      },
      // 用户数据
      Acolumns: [
        {
          title: '用户Id',
          dataIndex: 'userId',
          scopedSlots: { customRender: 'ActivityId' }
        },
        {
          title: '用户姓名',
          dataIndex: 'userName',
          scopedSlots: { customRender: 'ActivityName' }
        },
        {
          title: '用户手机',
          dataIndex: 'userPhone',
          scopedSlots: { customRender: 'ActivityTime' }
        },
        {
          title: '收货地址',
          dataIndex: 'shipping',
          scopedSlots: { customRender: 'ParticipatePeople' }
        },
        {
          title: '备注信息',
          dataIndex: 'remarks',
          scopedSlots: { customRender: 'ParticipateNumber' }
        },
        {
          title: '中奖时间',
          dataIndex: 'WinTime',
          scopedSlots: { customRender: 'GameNumber' }
        }
      ],
      userForm: {
        num: '',
        gamepeople: '',
        gamenum: '',
        plugnum: ''
      },
      Adata: [],
      condata: [],
      // 推广中的表单
      aform: {
        aone: 'plugin://wxd921098e57458ad8/zuizan?activityId=1'
      },
      id: {
        appId: '',
        verderId: ''
      }
    }
  },
  created () {
    this.add()
  },
  methods: {
    add () {
      this.appId = this.$utils.getUrlKey('appId')
      this.verderId = this.$utils.getUrlKey('venderId')
      AV.Cloud.run('decrypt', {
        appId: this.appId,
        verderId: this.verderId
      }).then(data => {
      })
      new AV.Query('ZZCommodity')
        .find().then(res => {
          this.data = JSON.parse(JSON.stringify(res))
        })
    },
    // 监听新增数据组件
    fatherMethod () {
      this.add()
    },
    // 提前结束活动
    end (record) {
      const todo = AV.Object.createWithoutData('ZZCommodity', record.objectId)
      todo.set('Activitystatus', '已结束')
      todo.save().then(res => {
        this.add()
      })
    },
    // 推广
    extension () {
      this.extensionvis = true
    },
    extensionOk () {
      this.extensionvis = false
    },
    extensionCancel () {
      this.extensionvis = false
    },
    // 编辑按钮
    edit (record) {
      this.recordID = record.objectId
      this.ruleForm.activityId = record.activityId
      this.ruleForm.mainTitle = record.mainTitle
      this.ruleForm.max = record.max
      this.ruleForm.activityStartDate = record.activityStartDate
      this.ruleForm.deadline = record.deadline
      this.ruleForm.Prize = record.Prize
      this.ruleForm.Cycle = record.Cycle
      this.visible = true
    },
    Startchange (value) {
      this.activityStartTime = value.format('YYYY-MM-DD HH:mm:ss')
    },
    Endchange (value) {
      this.deadline = value.format('YYYY-MM-DD HH:mm:ss')
    },
    // 对话框确定提交表单
    handleOk () {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          const todo = AV.Object.createWithoutData('ZZCommodity', this.recordID)
          todo.set('mainTitle', this.ruleForm.mainTitle)
          todo.set('max', this.ruleForm.max)
          todo.set('activityStartDate', this.activityStartTime)
          todo.set('deadline', this.deadline)
          todo.set('Prize', this.ruleForm.Prize)
          todo.set('Cycle', this.ruleForm.Cycle)
          todo.save().then(res => {
            this.add()
            this.visible = false
            this.$message.success('更新成功')
          })
        } else {
          this.$message.error('请检查配置信息')
        }
      })
    },
    // 删除
    remove (record) {
      const key = record.key
      const newData = this.data.filter(item => item.key !== key)
      this.data = newData
      const todo = AV.Object.createWithoutData('ZZCommodity', record.objectId)
      todo.destroy().then(res => {
        this.$message.success('删除成功')
      }, err => {
        console.log(err)
        this.$message.error('删除失败')
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    // 查看数据
    seedata (record) {
      this.recordID = record.objectId
      this.vis = true
      new AV.Query('Winningdata')
        .find().then(res => {
          this.userForm.num = res.length
        })
      this.userForm.gamepeople = record.ParticipatePeople
      this.userForm.gamenum = record.ParticipateNumber
      this.userForm.plugnum = record.plugnum
    },
    dataOk () {
      this.vis = false
    },
    dataCancel () {
      this.vis = false
    },
    // 查看详细信息
    detailed () {
      this.visdetailed = true
      new AV.Query('Winningdata')
        .find()
        .then(res => {
          this.Adata = JSON.parse(JSON.stringify(res))
        })
    },
    detailedOk () {
      this.visdetailed = false
    },
    detailedCancel () {
      this.visdetailed = false
    },
    conbtn () {
      new AV.Query('ZZCommodity')
        .get(this.recordID)
        .then(res => {
          this.condata = res.toJSON()
          console.log(this.condata)
        })
      this.configure = true
    },
    conOk () {
      this.configure = false
    },
    conCancel () {
      this.configure = false
    },
    // 复制
    copyo () {
      var clipboard = new Clipboard('.activity1')
      clipboard.on('success', e => {
        this.$message.success('已复制到粘贴板')
        // 释放内存
        clipboard.destroy()
      })
    },
    handleStartOpenChange () {
    }
  }
}
</script>

<style lang="less" scoped>
.box{
  width: 95%;
  margin: 50px auto;
}
.box-top{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 25px 0px;
}
.extension{
  width: 30%;
  margin: 10px 0px;
  margin-left: 125px;
  p{
    font-size:16px;
    color: black;
  }
  a{
    font-size: 12px;
    margin-left: 20px;
  }
}
.address{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>
